import { EpisodeOfCare } from '@/types/episodeOfCare';

export interface Props {
  episodeOfCare: EpisodeOfCare;
  personId?: string;
  setEditingProgramAndPhase: (editing: boolean) => void;
}

export enum SectionState {
  GRADUATING = 'GRADUATING',
  DISCHARGING = 'DISCHARGING',
  VIEWING = 'VIEWING'
}
